import React from 'react';
import { AlertTriangle } from 'lucide-react';

export function NxAlertStrip({ tone = 'amber', icon, title, body, action, className = '', ...rest }) {
  const toneCls = tone === 'red' ? 'nx-alert-strip--red'
                : tone === 'blue' ? 'nx-alert-strip--blue' : '';
  return (
    <div className={`nx-alert-strip ${toneCls} ${className}`.trim()} {...rest}>
      <span style={{ display: 'inline-flex' }}>{icon || <AlertTriangle size={18} />}</span>
      <div style={{ flex: 1, minWidth: 0 }}>
        {title && <div style={{ fontWeight: 800, fontSize: 14 }}>{title}</div>}
        {body && <div style={{ fontWeight: 600, fontSize: 12, opacity: 0.85 }}>{body}</div>}
      </div>
      {action}
    </div>
  );
}
